import React, { Component } from "react";
import { I18n } from "react-i18next";
import i18n from "../utils/i18n";
import Highlighter from "react-highlight-words";
import { Link } from "react-router-dom";
import ReactList from "react-list";
import WordDimension from "./WordDimension";
let wordDimension = new WordDimension();

const ResultItem = props => {
  return (
    <div>
      <div className="row detail-space-top-title">
        <div className="span12">
          <b>
            <Highlighter
              highlightClassName="highlighted"
              searchWords={[props.searchTerm]}
              autoEscape={true}
              textToHighlight={props.item.orgelbauer.orgelbauer}
            />
          </b>
        </div>
      </div>
      {props.item.orgelbauer.kontaktsichtbar && (
        <div>
          <div className="row">
            <div className="span2">{i18n.t("suchResultate.Geburt")}:</div>
            <div className="span1">{props.item.orgelbauer.geburt}</div>
          </div>
          <div className="row">
            <div className="span2">{i18n.t("suchResultate.Tod")}:</div>
            <div className="span1">{props.item.orgelbauer.tod}</div>
          </div>
          <div className="row">
            <div className="span12">{props.item.orgelbauer.kommentar}</div>
          </div>
        </div>
      )}
      <div className="row detail-space-top-element">
        <div className="span3 search-input-title">
          {i18n.t("suchResultate.Ort")}
        </div>
        <div className="span2 search-input-title">
          {i18n.t("suchResultate.Datum")}
        </div>
        <div className="span4 search-input-title">
          {i18n.t("suchResultate.Gebaude")}
        </div>
        <div className="span3 search-input-title">
          {i18n.t("suchResultate.Massnahme")}
        </div>
      </div>
      {props.item.massnahmen.map(
        ({ plz, ort, datum, gebaeude, massnahme, id }) => (
          <div className="row" key={id}>
            <div className="span3">
              {plz}{" "}
              <Highlighter
                highlightClassName="highlighted"
                searchWords={[props.searchTerm]}
                autoEscape={true}
                textToHighlight={ort}
              />
            </div>
            <div className="span2">
              <Highlighter
                highlightClassName="highlighted"
                searchWords={[props.searchTerm]}
                autoEscape={true}
                textToHighlight={datum ? datum : ""}
              />
            </div>
            <div className="span4">
              <Highlighter
                highlightClassName="highlighted"
                searchWords={[props.searchTerm]}
                autoEscape={true}
                textToHighlight={gebaeude}
              />
            </div>
            <div className="span2">
              <Highlighter
                highlightClassName="highlighted"
                searchWords={[props.searchTerm]}
                autoEscape={true}
                textToHighlight={massnahme ? massnahme : ""}
              />
            </div>
            <div className="span1 hslu-link">
              <Link to={`/detail/${id}`}>
                {i18n.t("navigation.Details")} &raquo;
              </Link>
            </div>
          </div>
        )
      )}
    </div>
  );
};

class OrgelbauerResult extends Component {
  constructor(props) {
    super(props);

    this.getHeight = this.getHeight.bind(this);
  }

  getHeight(index) {
    let orgelbauer = this.props.result[index].orgelbauer;
    let massnahmen = this.props.result[index].massnahmen;

    const heightOrgelbauer = 17;
    const heightOrgelbauerKontakt = orgelbauer.kontaktsichtbar ? 68 : 0;
    // die Höhe vom Kommentar zu erhanen ist recht trickey
    // eine Zeile ist ca. 150 Zeichen, da es eher Fliesstext ist, Zeilen mit dieser Länge zählen und mit der Zeilenhöhe multiplizieren
    const heightOrgelbauerKommentar = (orgelbauer.kommentar) ? orgelbauer.kommentar.length / 150 * 17 : 0;
    const heightMassnahmeTitel = 25; // with margin
    const heightMassnahmen = massnahmen.reduce(
      (acc, element) => acc + wordDimension.getHeight(element.gebaeude, 300),
      0
    );

    const heightMargin = 30;

    return (
      heightOrgelbauer +
      heightOrgelbauerKontakt +
      heightOrgelbauerKommentar +
      heightMassnahmeTitel +
      heightMassnahmen +
      heightMargin
    );
  }

  render() {
    if (!this.props.searchTerm || !this.props.result) {
      return null;
    }
    return (
      <I18n>
        {(t, { i18n }) => (
          <div>
            <div className="row">
              <div className="span5 search-result-title">
                {t("suchResultate.Suchresultate")}{" "}
                {this.props.result.reduce(
                  (acc, element) => acc + element.massnahmen.length,
                  0
                )}
              </div>
            </div>
            <ReactList
              itemRenderer={(index, key) => (
                <ResultItem
                  item={this.props.result[index]}
                  searchTerm={this.props.searchTerm}
                  key={key}
                />
              )}
              length={this.props.result.length}
              itemSizeGetter={this.getHeight}
              type="variable"
            />
          </div>
        )}
      </I18n>
    );
  }
}

export default OrgelbauerResult;



// WEBPACK FOOTER //
// ./src/search-unified/OrgelbauerResult.js